/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationIPWhitelist
 */
export interface OrganizationIPWhitelist {
    /**
     * The ID of the organization
     * @type {string}
     * @memberof OrganizationIPWhitelist
     */
    organization_id: string;
    /**
     * The whitelisted IP address or CIDR notation
     * @type {string}
     * @memberof OrganizationIPWhitelist
     */
    ip_address: string;
    /**
     * Optional description for the IP address
     * @type {string}
     * @memberof OrganizationIPWhitelist
     */
    description?: string;
    /**
     * ID of the user who added this IP address
     * @type {string}
     * @memberof OrganizationIPWhitelist
     */
    created_by?: string;
    /**
     * Timestamp when the IP address was added to the whitelist
     * @type {Date}
     * @memberof OrganizationIPWhitelist
     */
    created_at: Date;
    /**
     * Timestamp when the IP address was last updated
     * @type {Date}
     * @memberof OrganizationIPWhitelist
     */
    updated_at?: Date;
}

/**
 * Check if a given object implements the OrganizationIPWhitelist interface.
 */
export function instanceOfOrganizationIPWhitelist(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "organization_id" in value;
    isInstance = isInstance && "ip_address" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function OrganizationIPWhitelistFromJSON(json: any): OrganizationIPWhitelist {
    return OrganizationIPWhitelistFromJSONTyped(json, false);
}

export function OrganizationIPWhitelistFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationIPWhitelist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'],
        'ip_address': json['ip_address'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'created_by': !exists(json, 'created_by') ? undefined : json['created_by'],
        'created_at': (new Date(json['created_at'])),
        'updated_at': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
    };
}

export function OrganizationIPWhitelistToJSON(value?: OrganizationIPWhitelist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organization_id,
        'ip_address': value.ip_address,
        'description': value.description,
        'created_by': value.created_by,
        'created_at': (value.created_at.toISOString()),
        'updated_at': value.updated_at === undefined ? undefined : (value.updated_at.toISOString()),
    };
}

